// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.my-table[data-v-6bd3c3e2] {\n    background: transparent !important;\n}\n.theme--dark.my-table\n    > .v-data-table__wrapper\n    > table\n    > thead\n    > tr:last-child\n    > th[data-v-6bd3c3e2] {\n    border-bottom: 1px solid #967446 !important;\n    color: white !important;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
